export const applyStyles = (element: HTMLElement): void => {
    element.style.backgroundColor = 'black';
    element.style.width = '100%';
    element.style.height = '100%';
};